import { render } from "./DataExchangeLog.vue?vue&type=template&id=bd5c06e2&scoped=true"
import script from "./DataExchangeLog.vue?vue&type=script&lang=js"
export * from "./DataExchangeLog.vue?vue&type=script&lang=js"

import "./DataExchangeLog.vue?vue&type=style&index=0&id=bd5c06e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5c06e2"],['__file',"src/views/DataExchange/DataExchangeLog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd5c06e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd5c06e2', __exports__)) {
    api.reload('bd5c06e2', __exports__)
  }
  
  module.hot.accept("./DataExchangeLog.vue?vue&type=template&id=bd5c06e2&scoped=true", () => {
    api.rerender('bd5c06e2', render)
  })

}


export default __exports__